import {
    EmergencyContact,
    Communication,
    EnrollmentInfoPage,
    ResidencyLanguageCitizenship,
    StudentContacts,
    APManual,
    StudentInformationConsent,
    KinInfoShare,
    PreferredNamePronoun,
    BusRegistration,
    FileUploads
} from '../steps/';
import { useState, useContext, useEffect } from 'react';
import { FormContainer as Container, Spinner } from '../../components';
import { MultiStepForm, SideBar } from '../';
import FormContext from "../../context/FormContext.js";
import StaticDataContext from '../../context/StaticDataContext';
import { FormLayout } from '../../containers';
import { useNavigate } from 'react-router-dom';
import LoadingScreen from './LoadingPage.js';
import { callAPI } from '../../api/apiClient.js';
import { usePopup } from '../../context/PopupContext.js';

function SubmitStep() {
    const { formData, clearFormData } = useContext(FormContext);
    const [submitting, setSubmitting] = useState(false);
    const { showPopup } = usePopup();
    const navigate = useNavigate();

    const handleSubmit = async () => {
        setSubmitting(true);
        let submitResponse = "";

        try {
            const response = await callAPI("/submit-registration", 'POST', formData);
            submitResponse = response.data
            // if (response.data.status === "success") {
            //     alert("Registration submitted successfully!");
            // } else {
            //     alert("Failed to submit registration. Please try again.");
            // }
        } catch (error) {
            console.error("Error submitting registration:", error.message);
            alert("An error occurred while submitting the registration.");
        }

        const formSubmitted = {
            response: submitResponse,
        }


        //move formData from local to session
        sessionStorage.setItem("Old formData", JSON.stringify(formData));
        clearFormData({});
        
        localStorage.setItem("SUBMIT", JSON.stringify(formSubmitted));
        setSubmitting(false);
        navigate("/submit");
    };

    const handleSubmitHandler = () => {
        showPopup("You're about to submit this Registration form.", "Continue?", () => handleSubmit());
    }

    return (
        <Container>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <h1>You're Almost Done!</h1>
                <p>Before submitting, please take a moment to verify that all details are accurate.</p>
                <br />
                <p>Once you submit your information, changes can only be made by contacting the school.</p>
                <br />
                <hr />
                {
                    !submitting ?
                        <button type="button" onClick={handleSubmitHandler} className="default-btn-r" style={{}}>
                            Submit Registration
                        </button> :
                        <Spinner />
                }
            </div>
        </Container>
    );
}

const stepConfig = [
    { component: EnrollmentInfoPage, title: 'Student/Enrollment Information', condition: () => true },
    { component: Communication, title: 'Communication' },
    { component: StudentContacts, title: 'Student Contacts' },
    { component: EmergencyContact, title: 'Emergency Contact & Medical Information' },
    { component: ResidencyLanguageCitizenship, title: 'Residency/ Language/ Citizenship' },
    {
        component: FileUploads,
        title: 'Supporting Documents',
    },
    {
        title: 'Additional Form(s)',
        grouped: true,
        condition: (formData) => (formData.isBusRequired === "1"),
        content: [
            {
                component: BusRegistration,
                title: 'School Bus Student Registration',
                condition: (formData) => formData.isBusRequired === "1",
            },
        ]
    },
    {
        title: 'Information/ Consent',
        grouped: true,
        content: [
            { component: APManual, title: 'Administrative Procedure Manuals' },
            { component: StudentInformationConsent, title: 'Consent to Share Student Information' },
            {
                component: KinInfoShare,
                title: 'Kindergarten Sharing of Information Consent Form',
                condition: (formData) => formData.grade === "0K"
            },
            { component: PreferredNamePronoun, title: 'Consent For Use of Preferred Name or Pronoun(s)' },

        ],
    },
    { component: SubmitStep, title: 'Submit' },
];

function createGroupedSteps(groupedContent, formData) {
    return groupedContent
        .filter((subStep) => {
            // Check if the step has a condition and evaluate it
            if (subStep.condition && !subStep.condition(formData)) {
                return false;
            }
            return true;
        })
        .map((subStep) => ({
            content: <subStep.component />,
            title: subStep.title,
        }));
}

function getSteps({ formData }) {
    return stepConfig
        .filter((step) => {
            // Check if the step has a condition and evaluate it
            if (step.condition && !step.condition(formData)) {
                return false;
            }
            return true;
        })
        .map((step) => {
            if (step.grouped) {
                return {
                    title: step.title,
                    grouped: true,
                    content: createGroupedSteps(step.content, formData),
                };
            }
            return {
                content: <step.component />,
                title: step.title,
            };
        });
}

function RegistrationForm({ validateSteps = true }) {
    const { formData } = useContext(FormContext);
    const { loading, error } = useContext(StaticDataContext);
    const navigate = useNavigate();

    // Check if user should be at this stage.
    useEffect(() => {
        if (!sessionStorage.getItem("started") ||
            !formData["isCanCit"] ||
            (formData["isCanCit"] === "0" && !formData["workingWithSWIS"])
        ) {
            navigate("/initial-form");
            return
        }
    }, []);

    if (loading) {
        return (
            <LoadingScreen label={"Loading form. Please wait..."} />
        );
    }

    if (error) {
        return (
            <div className="error-screen">
                <p>Error loading data: {error.message}</p>
            </div>
        );
    }

    const steps = getSteps({ formData });
    return (
        <FormLayout type="sidebar">
            <MultiStepForm
                formId={"RegFormID"}
                steps={steps}
                ProgressBar={SideBar}
                validateFormStep={validateSteps}
            />
        </FormLayout>
    );
}

export default RegistrationForm;